import { ComponentPropsWithoutRef } from 'react';

export const SolidPlusIcon = ({
  ...props
}: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 20 19" fill="none">
      <mask id="mask0_1807_13809" x="0" y="0" width="20" height="19">
        <path
          d="M10 17.833a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z"
          fill="#000000"
          stroke="#000000"
          strokeWidth="1.667"
          strokeLinejoin="round"
        />
        <path
          d="M10 6.166v6.667M6.667 9.499h6.667"
          stroke="#000000"
          strokeWidth="1.667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_1807_13809)">
        <path d="M0-.5h20v20H0v-20Z" fill="#000000" />
      </g>
    </svg>
  );
};
